export const feesMasterData = [
  {
    key: "1",
    id: "FG80482",
    feesGroup: "Admission-Fees",
    feesType: "Tuition Fees",
    dueDate: "30 Jan 2025",
    amount: "1250",
    fineType: "None",
    fineClass: "badge badge-soft-warning",
    fineAmount: "200",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
  {
    key: "2",
    id: "FG80481",
    feesGroup: "Class 1 General",
    feesType: "Monthly Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "Percentage",
    fineClass: "badge badge-soft-info",
    fineAmount: "300",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
  {
    key: "3",
    id: "FG80481",
    feesGroup: "Monthly Fees",
    feesType: "Admission Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "Percentage",
    fineClass: "badge badge-soft-info",
    fineAmount: "300",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
  {
    key: "4",
    id: "FG80481",
    feesGroup: "Class 1 Lump Sum",
    feesType: "Bus Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "Percentage",
    fineClass: "badge badge-soft-info",
    fineAmount: "300",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
  {
    key: "5",
    id: "FG80481",
    feesGroup: "Class 1- I Installment",
    feesType: "Monthly Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "Fixed",
    fineClass: "badge badge-soft-danger",
    fineAmount: "300",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
  {
    key: "6",
    id: "FG80481",
    feesGroup: "Class 1-II Installment",
    feesType: "Monthly Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "Percentage",
    fineClass: "badge badge-soft-info",
    fineAmount: "300",
    status: "Inactive",
    statusClass: "badge badge-soft-danger",
  },
  {
    key: "7",
    id: "FG80481",
    feesGroup: "Discount",
    feesType: "Topper Discount",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "None",
    fineClass: "badge badge-soft-warning",
    fineAmount: "300",
    status: "Inactive",
    statusClass: "badge badge-soft-danger",
  },
  {
    key: "8",
    id: "FG80481",
    feesGroup: "Class 3- I Installment",
    feesType: "3rd-Installment-Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "None",
    fineClass: "badge badge-soft-warning",
    fineAmount: "300",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
  {
    key: "9",
    id: "FG80481",
    feesGroup: "Class 2- I Installment",
    feesType: "3rd-Installment-Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "Fixed",
    fineClass: "badge badge-soft-danger",
    fineAmount: "300",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
  {
    key: "10",
    id: "FG80481",
    feesGroup: "Class 4- I Installment",
    feesType: "3rd Installment Fees",
    dueDate: "12 May 2025",
    amount: "250",
    fineType: "Fixed",
    fineClass: "badge badge-soft-danger",
    fineAmount: "300",
    status: "Active",
    statusClass: "badge badge-soft-success",
  },
];